import {Pipe, PipeTransform} from "@angular/core";
import {Name} from "@models/booking.models";

@Pipe({name: 'passengerInitials', standalone: true})
export class PassengerInitialsPipe implements PipeTransform {
  transform(
    name: Name | null | undefined
  ): string | undefined {
    if (!name) {
      return;
    }

    const firstName = name.first;
    const lastName = name.last;

    if (firstName && lastName) {
      return `${firstName.charAt(0).toUpperCase()}${lastName.charAt(0).toUpperCase()}`;
    } else {
      return;
    }
  }
}
